import {Component, ViewChild} from '@angular/core';
import {ManagementComponent} from "../management";
import {PhotoOrder} from "../../../shared/models/cameralla-photo-order.model";
import {CTableCell, CTableConfig} from "../../../core/ui/c-table/c-table-config";
import {CTableComponent} from "../../../core/ui/c-table/c-table.component";
import {FilterPhotoForm} from "../filter-photo-form/filter-photo-form";
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-cl-act-col',
    template: `<button class="btn btn-md btn-primary text-white mr-2" type="button" (click)="extraData.edit(row.entity)">Edit</button>
    <button class="btn btn-md btn-secondary text-white" type="button" (click)="extraData.delete(row.entity)">Remove</button>`
})
export class CLActColComponent implements CTableCell {
    extraData;
    row;
    column;
}

@Component({
    selector: 'app-filter-management',
    templateUrl: './filter-photo-management.html',
    styleUrls: ['filter.css'],
})
export class FilterPhotoManagement extends ManagementComponent {

    categories = [];
    selectedFilters = [];
    photoOrder: PhotoOrder;
    loaded: boolean = false;
    changeOrderPromise;
    categoryNameArr = [];
    defaultFilterList = [];
    hidePartner = false;
    groupId = null;

    @ViewChild('filterTable')
    filterTable: CTableComponent;

    filterModel = {
        text: '',
        tags: [],
        sort_by: {},
        order: "",
        categoriesList: [],
        partnerId : ''
    };

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.defaultFilterList, event.previousIndex, event.currentIndex);
    }

    getFilterList(){
        this.http.get(FilterPhotoForm.filterAPI + `?filter[where][groupId]=null`)
            .subscribe(
                (res: any) => {
                    if (res.Data.defaultFilters) {
                        if (this.onlyKampsport) {
                            this.defaultFilterList = res.Data.defaultFilters.filter(item => {
                                return item.partner.value == 'kampsport';
                            });
                        } else {
                            this.defaultFilterList = res.Data.defaultFilters;
                        }
                    }
                },
                (error) => {
                    this.toastr.error(error.error.Message, 'Error');
                }
            );
    }

    ngOnInit() {
        this.getFilterList();
    }

    public removeFilter(filter){
        const isConfirm = confirm(`Do you really want to remove the ${filter.text} filter ?`);
        if (isConfirm) {
            this.http.delete(FilterPhotoForm.filterAPI + '/' + filter.id)
                .subscribe(
                    (res: any) => {
                        this.getFilterList();
                    },
                    (error) => {
                        this.toastr.error(error.error.Message, 'Update failed');
                    }
                );
        }
    }

    public changeFilterOrder(){
        this.changeOrderPromise = this.http.put(FilterPhotoForm.filterAPI + '/' + 'order', this.defaultFilterList)
            .subscribe(
                (res: any) => {
                    if (res.Data) {

                        // Config permission for user Kampsport can edit filter
                        if (this.onlyKampsport) {
                            this.defaultFilterList = res.Data.filter(item => {
                                return item.partner.value == 'kampsport';
                            });
                        } else {
                            this.defaultFilterList = res.Data;
                        }
                        this.toastr.success('Change order default filter successfully', 'Success');
                    }
                },
                (error) => {
                    this.toastr.error(error.error.Message, 'Update failed');
                }
            );
    }

    openFilterForm(filterModel, option) {
        const modal = this._modalService.open(FilterPhotoForm, {centered: true, size: 'lg'});
        (<FilterPhotoForm>modal.componentInstance).filterModel = Object.assign({}, filterModel);
        (<FilterPhotoForm>modal.componentInstance).isEdit = (option == "edit");
        (<FilterPhotoForm>modal.componentInstance).groupId = this.groupId;
        (<FilterPhotoForm>modal.componentInstance).onRefresh.subscribe((e)=> {
            this.getFilterList();
        })
    }
}
